import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs/Observable';
import {AuthService} from '../auth.service';
import {AppConstants} from '../shared/app.constants';

@Injectable()
export class FreelancersService {

  constructor(private http: HttpClient, private auth: AuthService, private appConstants: AppConstants) {
  }

  getAllFreelancers(): Observable<any> {
    const url = environment.apiBase + 'freelancers';
    const headers = this.auth.getAuthorizationHeaders();
    return this.http.get(url, {headers}).map(res => res).catch(this.appConstants.errorHandler);
  }

  getFreelancer(id: string): Observable<any> {
    const url = environment.apiBase + 'freelancers/' + id;
    const headers = this.auth.getAuthorizationHeaders();
    return this.http.get(url, {headers}).map(res => res).catch(this.appConstants.errorHandler);
  }

  uploadCoverImageToS3(body): Observable<any> {
    const url = environment.apiBase + 's3/sign';
    const headers = {headers: this.auth.getAuthorizationHeaders()};
    return this.http.post(url, body, headers).map(response => response).catch(this.appConstants.errorHandler);
  }

  registerFreelancer(body): Observable<any> {
    const url = environment.apiBase + 'register';
    const headers = {headers: this.auth.getAuthorizationHeaders()};
    return this.http.post(url, body, headers).map(response => response).catch(this.appConstants.errorHandler);
  }

  updateFreelancer(body): Observable<any> {
    const url = environment.apiBase + 'users/' + body.id;
    const headers = {headers: this.auth.getAuthorizationHeaders()};
    return this.http.put(url, body, headers).map(response => response).catch(this.appConstants.errorHandler);
  }

  deleteFreelancer(freelancerId): Observable<any> {
    const url = environment.apiBase + `users/${freelancerId}`;
    const headers = this.auth.getAuthorizationHeaders();
    return this.http.delete(url, {headers}).map(response => response).catch(this.appConstants.errorHandler);
  }

}



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/freelancers/freelancers.service.ts